<p-card>
  <div class="flex items-center justify-between mb-1">
    <div class="flex items-center gap-2">
      <i class="pi pi-file-edit text-gray-600"></i>
      <h3 class="text-lg font-semibold text-gray-900">Notes</h3>
    </div>

    @if (!showNewNoteForm() && !editingNoteId()) {
      <p-button
        label="+ Add Note"
        size="small"
        styleClass="bg-blue-600 hover:bg-blue-700 text-white border-0"
        [disabled]="!resolveEntityId()"
        (onClick)="showNewNote()"
      ></p-button>
    }
  </div>

  <div class="w-full">
    <div class="hidden" [formGroup]="formGroup()">
      <app-one-to-many
        title="Note"
        [service]="noteService"
        [defaultSort]="defaultSort()"
        [cols]="cols()"
        [componentType]="noteComponentType"
        [fields]="noteFields"
        id="noteID"
        [isViewOnly]="true"
        (onDataChange)="onDataNote($event)"
        [parentIdKey]="parentIdKey()"
        [foreingKeyName]="foreignKeyName()"
        [entityType]="entityType()"
      ></app-one-to-many>
    </div>

    @if (showNewNoteForm() || editingNoteId()) {
      <div class="new-note-form mb-4">
        <div class="note-form-row">
          <div class="note-form-field">
            <label class="note-form-label">Category</label>
            <p-dropdown
              [formControl]="noteForm.controls['category']"
              [options]="categories"
              optionValue="id"
              optionLabel="description"
              placeholder="Select Category"
              (onChange)="selectSubCategories($event.value)"
              styleClass="w-full"
            ></p-dropdown>
          </div>

          <div class="note-form-field">
            <label class="note-form-label">Sub Category</label>
            <p-dropdown
              [formControl]="noteForm.controls['subCategory']"
              [options]="filteredSubCategories()"
              optionValue="id"
              optionLabel="description"
              placeholder="Select Sub Category"
              styleClass="w-full"
            ></p-dropdown>
          </div>
        </div>

        <div class="note-form-field">
          <label class="note-form-label">
            Content <span class="text-red-600">*</span>
          </label>
          <textarea
            [formControl]="noteForm.controls['content']"
            class="w-full note-content-textarea"
            rows="4"
            placeholder="Enter note content..."
            (keydown)="onNoteContentKeydown($event)"
            (blur)="onNoteContentBlur()"
          ></textarea>
        </div>

        <div class="note-form-actions">
          <p-button
            label="Cancel"
            size="small"
            styleClass="bg-slate-50 hover:bg-slate-100 border-gray-300 text-black"
            (onClick)="cancelNoteForm()"
            [disabled]="savingNote()"
          ></p-button>

          <p-button
            [label]="editingNoteId() ? 'Update' : 'Save'"
            size="small"
            [disabled]="noteForm.invalid || savingNote()"
            (onClick)="saveNote()"
          >
            @if (savingNote()) {
              <span class="inline-block h-2.5 w-2.5 rounded-full bg-gray-400 animate-pulse mr-2"></span>
            }
          </p-button>
        </div>
      </div>
    }

    @if (paginatedNotes().length > 0) {
      <div class="notes-cards-container mb-2" [class.notes-cards-container--paged]="enablePagination()">
        @for (note of paginatedNotes(); track note.noteID) {
          <div
            class="note-card"
            [class.note-card-clickable]="!isEditingThisNote(note) && !savingNote() && !deletingNoteId()"
            (click)="!isEditingThisNote(note) && !savingNote() && !deletingNoteId() ? startEditNote(note) : null"
          >
            <div class="note-card-header">
              <div class="note-top-row">
                <span class="note-category-title">{{ getCategoryDescription(note.category) }}</span>
                <div class="flex items-center gap-2 shrink-0">
                  @if (note.createdOn) {
                    <button
                      type="button"
                      class="date-toggle-button"
                      (click)="toggleNoteDateDisplay(note, $event)"
                    >
                      @if (isOfficialNoteDate(note)) {
                        {{ note.createdOn | utcToLocal | date: "MMM d, yyyy h:mm a" }}
                      } @else {
                        {{ note.createdOn | utcToLocal | relativeDateLabel }}
                      }
                    </button>
                  }
                  @if (!isEditingThisNote(note)) {
                    <button
                      type="button"
                      class="note-action-icon note-inline-remove-btn"
                      [class.opacity-40]="isDeletingNote(note)"
                      [class.pointer-events-none]="savingNote() || deletingNoteId()"
                      (click)="$event.stopPropagation(); confirmDeleteNote($event, note)"
                      [attr.tabindex]="savingNote() || deletingNoteId() ? -1 : 0"
                      (keydown.enter)="$event.stopPropagation(); confirmDeleteNote($event, note)"
                      (keydown.space)="$event.preventDefault(); $event.stopPropagation(); confirmDeleteNote($event, note)"
                      [attr.aria-label]="'Delete note'"
                    >
                      <i class="pi pi-times text-sm" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              </div>

              <h4 class="note-title">
                @if (note.createdOn) {
                  <div class="date-time-display">
                    <div class="note-second-row">
                      @if (note.subCategory) {
                        <span class="note-subcategory-title">{{ getSubCategoryDescription(note.subCategory) }}</span>
                      }
                      @if (getNoteAuthorDisplay(note)) {
                        <span class="author-part">{{ getNoteAuthorDisplay(note) }}</span>
                      }
                    </div>
                  </div>
                } @else {
                  <span>Note</span>
                }
              </h4>
            </div>

            <div class="note-card-body">
              <p class="note-content">{{ note.content || '--' }}</p>
            </div>
          </div>
        }
      </div>

      @if (enablePagination() && notesTotal() > pageSize()) {
        <app-pagination-mobile-version
          [totalRecords]="notesTotal()"
          [skip]="notesSkip()"
          [take]="notesTake()"
          [rowsPerPageOptions]="rowsPerPageOptions()"
          (pageChange)="onNotesPageChange($event)"
        >
        </app-pagination-mobile-version>
      }
    }
  </div>
</p-card>
<p-confirmDialog styleClass="quote-delete-confirm-dialog" />
